// src/components/products/ProductForm/GeneralInfoSections/SupplierServiceSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const SupplierServiceSection = ({
    formData,
    errors,
    isArabic,
    selectedSupplier,
    handleSupplierChange,
    handleServiceChange,
    suppliersOptions,
    servicesOptions,
    loadingSuppliers,
    loadingServices,
}) => {
    return (
        <Grid container spacing={3}>
            {/* Supplier */}
            <Grid item xs={12} md={4}>
                <FormInput
                    label={isArabic ? 'المورد' : 'Supplier'}
                    type="select"
                    name="supplier_id_temp"
                    value={selectedSupplier || ''}
                    onChange={handleSupplierChange}
                    required
                    disabled={loadingSuppliers}
                    options={suppliersOptions}
                />
            </Grid>

            {/* Service */}
            <Grid item xs={12} md={8}>
                <FormInput
                    label={isArabic ? 'الخدمة' : 'Service'}
                    type="select"
                    name="service_id"
                    value={formData.service_id || ''}
                    onChange={handleServiceChange}
                    required
                    disabled={!selectedSupplier || loadingServices}
                    error={!!errors.service_id}
                    helperText={errors.service_id}
                    options={servicesOptions}
                />
            </Grid>
        </Grid>
    );
};

export default SupplierServiceSection;
